export class ClaimOwnerDetails { 
    refNo!: number;
    consultantID!: number;
    consultant!: string;    
    consultantEmail!: string;
    coordinatorID!: number;
    coordinator!: string;
    coordinatorEmail!: string;
    teamLeaderID!: number;
    teamLeader!: string;
    teamLeaderEmail!: string;
    officeContactID!: number;
    officeContact!: string;
    officeContactEmail!: string;
    caseNo!: string;
    wiPlink!: string;
    lastName!: string;
    isAssessorExternal!: number;
    team!: string;
    teamEmail!: string;
}